// extracted by mini-css-extract-plugin
module.exports = {"link":"b429494557--link--Udy7o","arrow":"b429494557--arrow--A6LkA"};